module.exports = __webpack_public_path__ + "img/sanwei.4194ca9f.png";